module.exports = __webpack_public_path__ + "img/800x450.837674c.gif";